(function () {
  var KEY = 'tp_wishlist';

  function load() {
    try {
      var data = JSON.parse(localStorage.getItem(KEY)) || [];
      return data.map(function (item) {
        return typeof item === 'string'
          ? { handle: item, variantId: null }
          : item;
      });
    } catch (e) { return []; }
  }

  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('tp:wishlist:change', { detail: { list: list } }));
  }

  // Read the currently selected variant ID for a product page button.
  // Tries three sources in order of reliability.
  function getCurrentVariantId(formId) {
    if (!formId) return null;
    var form = document.getElementById(formId);
    if (!form) return null;
    // 1. Hidden input updated by Dawn after variant selection
    var hidden = form.querySelector('input[name="id"]');
    if (hidden && hidden.value) return String(hidden.value);
    return null;
  }

  function getVariantId(btn) {
    var formId = btn.getAttribute('data-wishlist-form-id');
    if (formId) {
      var vid = getCurrentVariantId(formId);
      if (vid) return vid;
    }
    return btn.getAttribute('data-wishlist-variant-id') || null;
  }

  window.TPWishlist = {
    add: function (handle, variantId) {
      var l = load();
      var vid = variantId ? String(variantId) : null;
      var exists = l.some(function (i) {
        return i.handle === handle && String(i.variantId) === String(vid);
      });
      if (!exists) { l.push({ handle: handle, variantId: vid }); save(l); }
    },
    remove: function (handle, variantId) {
      var vid = variantId ? String(variantId) : null;
      save(load().filter(function (i) {
        return !(i.handle === handle && String(i.variantId) === String(vid));
      }));
    },
    toggle: function (handle, variantId) {
      TPWishlist.has(handle, variantId)
        ? TPWishlist.remove(handle, variantId)
        : TPWishlist.add(handle, variantId);
    },
    // null variantId = true if ANY variant of this product is saved (collection cards)
    has: function (handle, variantId) {
      var list = load();
      if (variantId == null) {
        return list.some(function (i) { return i.handle === handle; });
      }
      return list.some(function (i) {
        return i.handle === handle && String(i.variantId) === String(variantId);
      });
    },
    getAll: function () { return load(); },
    count: function () { return load().length; }
  };

  function updateBtn(btn) {
    var h = btn.getAttribute('data-wishlist-handle');
    var vid = getVariantId(btn);
    var active = TPWishlist.has(h, vid);
    btn.classList.toggle('tp-wishlist-btn--active', active);
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Save to wishlist');
  }

  function refreshProductButtons(formId) {
    document.querySelectorAll('[data-wishlist-form-id="' + formId + '"]').forEach(updateBtn);
  }

  function updateCounts() {
    var n = TPWishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.closest('.tp-wishlist-count').style.display = n > 0 ? '' : 'none';
    });
  }

  function init() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';
      updateBtn(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var h = btn.getAttribute('data-wishlist-handle');
        var vid = getVariantId(btn);
        TPWishlist.toggle(h, vid);
        updateBtn(btn);
      });
    });
    updateCounts();
  }

  // Detect variant changes. We use three complementary approaches:

  // 1. Standard change event (fires when radio selection changes)
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return;
    // Get the form ID from the attribute (more reliable than .form property here)
    var formId = target.getAttribute('form') || (target.form && target.form.id);
    if (!formId || formId.indexOf('product-form-') !== 0) return;
    // Give Dawn time to update the hidden input, then refresh
    setTimeout(function () { refreshProductButtons(formId); }, 50);
  });

  // 2. Click on variant labels (catches cases where change event is swallowed)
  document.addEventListener('click', function (e) {
    var label = e.target.closest('label');
    if (!label) return;
    var forId = label.getAttribute('for');
    if (!forId) return;
    var input = document.getElementById(forId);
    if (!input || input.type !== 'radio') return;
    var formId = input.getAttribute('form') || (input.form && input.form.id);
    if (!formId || formId.indexOf('product-form-') !== 0) return;
    setTimeout(function () { refreshProductButtons(formId); }, 50);
  });

  // 3. Poll every 150ms as a safety net — catches any missed updates
  setInterval(function () {
    document.querySelectorAll('[data-wishlist-form-id]').forEach(function (btn) {
      var formId = btn.getAttribute('data-wishlist-form-id');
      var vid = getCurrentVariantId(formId);
      if (vid && btn.getAttribute('data-wishlist-variant-id') !== vid) {
        btn.setAttribute('data-wishlist-variant-id', vid);
        updateBtn(btn);
      }
    });
  }, 150);

  document.addEventListener('tp:wishlist:change', function () {
    document.querySelectorAll('[data-wishlist-handle]').forEach(updateBtn);
    updateCounts();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
